module.exports = "query User {\n  user {\n    name\n    email\n    last_name\n    avatar\n    cashback\n    engagement_balance\n    cashback_total\n    awards_balance\n    email\n    id\n    gender\n    state\n    city\n    birthday\n    phone\n    news\n    has_password\n    vidalink_expire_date\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/User.graphql
// module id = 1995
// module chunks = 1611